import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../css/teacher_list.css';
import ApiService from '../../../../services/api'
import  Add from '../../../../media/add.png';
import  Edit from '../../../../media/edit.png';
import  Delete from '../../../../media/delete.png';
import  Teacher from '../../../../media/teacher.png';
import Search from '../../../../media/search.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';

const TeacherList = () => {
  const [teachers, setTeachers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchTeachers = async () => {
    try {
      const res = await ApiService.getTeachers();
      setTeachers(res);
    } catch (err) {
      console.error('Errore:', err);
    } finally {
      setLoading(false);
    }
  };

  fetchTeachers();
}, []);


 const normalizedSearch = search.trim().toLowerCase();

 const filteredTeachers = teachers.filter(t => {
  const fullName = `${t.first_name} ${t.last_name}`.toLowerCase();
  return fullName.includes(normalizedSearch);
});



  const handleDelete = async (slug) => {
   
    confirmToast({
            message: `Sei sicuro di voler eliminare questo insegnante?`,
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                await ApiService.deleteTeacher(slug);
                setTeachers(prev => prev.filter(t => t.slug !== slug));
                toast.success(`Insegnante eliminato con successo`);
              } catch (err) {
                toast.error("Errore durante l'eliminazione");
                      
              }
            },
          });
  };

  return (
    <div className="teacher-list-container">
      <div className="teacher-list-header" style={{marginBottom:'50px'}}>
        <h2><img src={Teacher} alt="" className="section-image" />Insegnanti</h2>
        <div className="search-zone">
          <img src={Search} alt="Cerca" className="search-image" />
          <input
          className='search-area'
          type="text"
          placeholder="Cerca insegnante..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button className="create-button" onClick={() => navigate('crea')}><img src={Add} alt="Aggiungi" className="button-image" /></button>
      </div>

      {loading ? (
        <p>Caricamento...</p>
      ) : teachers.length === 0 ? (
        <p>Nessun insegnante disponibile.</p>
      ) : (
        <ul className="teacher-list">
          {filteredTeachers.map((teacher) => (
            <li key={teacher.id} className="teacher-card"> 
              <img
                src={teacher.img_profile}
                alt="Profilo"
                className="teacher-avatar"
              />
              <div className="teacher-info">
                <strong>{teacher.first_name} {teacher.last_name}</strong>
                <p>{teacher.professional_qualification}</p>
              </div>
              <div className="teacher-actions">
                <button
                  className="create-button"
                  onClick={() => navigate(`modifica/${teacher.slug}`)}
                >
                  <img src={Edit} alt="Modifica" className="button-image" />
                </button>
                <button
                  className="create-button"
                  onClick={() => handleDelete(teacher.slug)}
                >
                  <img src={Delete} alt="Elimina" className="button-image" />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TeacherList;

